module.exports = require("@workbench-stack/platform/lib/paths");